<template>
  <div class="page modal-page-scroll d-flex flex-column">
    <div class="row header-page w-100">
      <div class="col">
        <h3>
          Archivio simulazioni
        </h3>
      </div>
    </div>
    <div class="row form-data mt-3 w-100">
      <div class="col mt-3">
        <div class="table-data archive-list">
          <b-table
            id="simulationTable"
            small
            :items="simulationArchive.data"
            :fields="simulationArchive.fields"
            sort-icon-left
          >
            <template v-slot:cell(created_at)="data">
              {{ data.value | moment("DD/MM/YYYY") }}
            </template>
            <template v-slot:cell()="data">
              {{ data.value }}
            </template>
            <template v-slot:cell(export_file)="data">
              <b-button
                variant="link w-auto h-auto"
                size="sm"
                @click="showSimulation(data.value)"
                >Visualizza</b-button
              >
            </template>
            <template v-slot:cell(uuid)="data">
              <b-button
                variant="link red-link w-auto h-auto"
                size="sm"
                @click="deleteSimulation(data.value)"
                >Cancella</b-button
              >
            </template>
          </b-table>
          <div class="overflow-auto mt-4">
            <b-pagination
              v-if="simulationArchive.meta.last_page > 1"
              v-model="currentPage"
              :total-rows="simulationArchive.meta.total"
              :per-page="simulationArchive.meta.per_page"
              aria-controls="simulationTable"
              :hide-goto-end-buttons="true"
              prev-text="Indietro"
              next-text="Avanti"
              last-text="Fine"
              align="center"
              @change="loadSimulations"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { replaceDotWithComma } from "../../utils/generic.utils";
import { simulationService } from "../../services/simulation.service";
import { SimulationsData } from "../../data/simulations.data";
export default {
  name: "Archive",
  props: {
    type: String
  },
  data: () => {
    return {
      val: false,
      simulationArchive: SimulationsData,
      currentPage: 1
    };
  },
  created: function() {
    this.loadSimulations();
  },
  methods: {
    loadSimulations(page = 1) {
      simulationService
        .getSimulations(page)
        .then(res => {
          this.simulationArchive.meta = res.meta;
          this.simulationArchive.data = res.data.map(simulation => {
            return {
              ...simulation,
              full_name: simulation.client ? simulation.client.full_name : null,
              email: simulation.client ? simulation.client.email : null
            };
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    showSimulation(url) {
      let pdf = url.replace('http:', 'https:');
      window.open(pdf, "_blank");
    },
    deleteSimulation(uuid) {
      if (confirm("Sei sicuro di voler cancellare la simulazione?")) {
        simulationService
          .deleteSimulation(uuid)
          .then(() => {
            this.loadSimulations();
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  },
  filters: {
    numberFilter(value) {
      return replaceDotWithComma(value);
    }
  }
};
</script>
